import { useContext, useState } from "react";

import { OriginatorsDataContext } from "../../common/data/lookup-data-providers/OriginatorsDataProvider";
import { DeliveryType } from "../../common/types/DeliveryType";
import { DefaultDelivery, DeliveryInfoFormInputs } from "./DeliveryInfoForm";

export const useDeliveryInfoForm = (defaultDelivery?: DefaultDelivery) => {
    const { originators } = useContext(OriginatorsDataContext);
    const [isCancelDialogHidden, setIsCancelDialogHidden] = useState<boolean>(true);

    const defaultValues = createDefaultValues(defaultDelivery);

    const showCancelDialog = () => {
        setIsCancelDialogHidden(false);
    };

    const hideCancelDialog = () => {
        setIsCancelDialogHidden(true);
    };

    return {
        defaultValues,
        isCancelDialogHidden,
        originators,
        showCancelDialog,
        hideCancelDialog
    };
};

const createDefaultValues = (defaultDelivery?: DefaultDelivery): DeliveryInfoFormInputs => {
    if (!defaultDelivery) {
        return {
            deliveryName: "",
            deliveryEmail: "",
            deliverySubject: "",
            deliveryRef: "",
            deliveryMessage: "",
            deliveryType: DeliveryType.Upload.toString(),
            arrivalDate: new Date(),
            originatorId: ""
        };
    }

    return {
        deliveryName: defaultDelivery.sender.name ?? "",
        deliveryEmail: defaultDelivery.sender.email ?? "",
        deliverySubject: defaultDelivery.sender.subject ?? "",
        deliveryRef: "",
        deliveryMessage: defaultDelivery.sender.message ?? "",
        deliveryType: DeliveryType.Upload.toString(),
        arrivalDate: new Date(defaultDelivery.file.arrivalDate),
        originatorId: defaultDelivery.originator?.id ?? ""
    };
};
